function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.215 21.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close Window") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.107 3.107a1.64 1.64 0 0 0 0 2.322l5.178 5.178-5.178 5.178a1.64 1.64 0 0 0 0 2.323c.644.644 1.68.643 2.323 0l5.178-5.178 5.178 5.178a1.64 1.64 0 0 0 2.323 0 1.64 1.64 0 0 0-.001-2.322l-5.178-5.178 5.179-5.179a1.64 1.64 0 0 0 0-2.322 1.64 1.64 0 0 0-2.323 0l-5.18 5.178-5.178-5.178a1.637 1.637 0 0 0-2.321-.001",
    style: {
      strokeWidth: 10.0724
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.eaebf4ce85f84ff46fcee1696ced8aea.svg";
export { ForwardRef as ReactComponent };